import React from 'react'
import {Link} from 'react-router-dom'

import styles from './styles.module.scss'
import {
  useEventTransactionData,
  useUserData,
  useParamsInteger,
} from '../../../pages/OrderManager/hooks'

const TableHeader: React.FC = () => {
  return (
    <thead>
      <tr>
        <th>Date</th>
        <th>Transaction</th>
        <th>Amount</th>
      </tr>
    </thead>
  )
}
const NoTransactionMsg: React.FC = () => {
  return (
    <tr>
      <td className={styles.errorMessage} colSpan={3} style={{textAlign: 'center'}}>
        No Transactions Found
      </td>
    </tr>
  )
}

export const TransactionHistory: React.FC = () => {
  const {orderId, eventId} = useParamsInteger(['eventId', 'orderId'])

  const {data: userData} = useUserData()
  const {data: eventTransactionData} = useEventTransactionData(eventId, userData?.id)

  const transactions = eventTransactionData?.transactions.filter((transaction) =>
    transaction.orders.some((order) => order.id === orderId),
  )

  const rows = transactions?.map(({createdOn, id, total}) => {
    return (
      <tr key={id}>
        <td>{new Date(createdOn).toLocaleDateString()}</td>
        <td>
          <Link to={`/receipt/${eventId}`}>{id}</Link>
        </td>
        <td>{`$${total}`}</td>
      </tr>
    )
  })

  return (
    <table className={styles.table}>
      <TableHeader />
      <tbody>{!rows?.length ? <NoTransactionMsg /> : rows}</tbody>
    </table>
  )
}
